import React from 'react';
import { Heading } from '@bnnvara/typography';
import styled from 'styled-components';
import NextLink from 'next/link';
import PropTypes from 'prop-types';
import { track } from '@bnnvara/analytics/src/track';

export const Title = styled(Heading)`
  margin-bottom: 1rem;
`;

export const RemovableCardContainer = styled.div`
  position: relative;
`;

export const RemoveButtonContainer = styled.div`
  color: lime;
  position: absolute;
  z-index: 10;
  top: 0;
  right: 0;
`;

export const FollowableLinkEl = styled.a`
  display: block;
`;

export const FollowableLink = ({ href, children, category, label }) => (
  <NextLink
    href={href}
    onClick={() => {
      track(category, 'click', label);
    }}
  >
    <FollowableLinkEl href={href}>{children}</FollowableLinkEl>
  </NextLink>
);

FollowableLink.propTypes = {
  children: PropTypes.node,
  href: PropTypes.string.isRequired,
  category: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
};

export const FollowableButtonContainer = styled.div`
  margin-top: 24px;

  > div {
    display: inline-block;
  }
`;
